/**
 * setToken
 * @param {string} token
 * @param {string} type
 */
export const setToken = (token, type = "refreshToken") => {
  localStorage.setItem(type, token)
}

/**
 * getToken
 * @param {string} type
 * @returns {string}
 */
export const getToken = (type = "refreshToken") => {
  return localStorage.getItem(type)
}

/**
 * removeToken
 * @param {string} type
 */
export const removeToken = (type = "refreshToken") => {
  localStorage.removeItem(type)
}
